import { render } from "./OcrVerificationForm.vue?vue&type=template&id=b4469b4a"
import script from "./OcrVerificationForm.vue?vue&type=script&lang=js"
export * from "./OcrVerificationForm.vue?vue&type=script&lang=js"

import "./OcrVerificationForm.vue?vue&type=style&index=0&id=b4469b4a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__